<template>
  <div class="container mt-5">
    <div class="text-center success-page">
      <div class="success-icon-container mb-4">
        <i class="mdi mdi-check-circle success-icon"></i>
      </div>
      
      <h1 class="success-title mb-3">Payment Successful!</h1>
      
      <div class="success-message mb-4">
        <p class="lead">
          Thank you for your payment. Your subscription has been activated.
        </p>
        <p>
          You now have access to all premium features including advanced hunt planning tools, 
          priority support, and exclusive hunting insights.
        </p>
      </div>

      <div class="premium-features mb-4">
        <h5 class="mb-3">Your Premium Benefits:</h5>
        <div class="row">
          <div class="col-md-6">
            <div class="feature-item">
              <i class="mdi mdi-map-marker-plus text-primary"></i>
              <span>Advanced hunt planning tools</span>
            </div>
            <div class="feature-item">
              <i class="mdi mdi-headset text-primary"></i>
              <span>Priority customer support</span>
            </div>
          </div>
          <div class="col-md-6">
            <div class="feature-item">
              <i class="mdi mdi-chart-line text-primary"></i>
              <span>Exclusive hunting insights</span>
            </div>
            <div class="feature-item">
              <i class="mdi mdi-map text-primary"></i>
              <span>Advanced mapping features</span>
            </div>
          </div>
        </div>
      </div>

      <div class="action-buttons">
        <button @click="goToHome" class="btn btn-primary btn-lg">
          <i class="mdi mdi-home me-2"></i>
          Go to Dashboard
        </button>
      </div>

      <div class="receipt-info mt-4">
        <p class="text-muted">
          <i class="mdi mdi-email me-2"></i>
          A receipt has been sent to your email address.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'PaymentSuccess',
  data() {
    return {
      isLoading: true,
      error: null
    };
  },
  async mounted() {
    try {
      // Make the whoami API call to get user data including subscription status
      const response = await fetch(process.env.VUE_APP_API_BASE_URL + '/api/customers/whoami', {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const userData = await response.json();
        // Update user data in the store
        this.setUser(userData);
        this.isLoading = false;
      } else {
        this.error = 'Failed to fetch user data';
        this.isLoading = false;
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
      this.error = 'An error occurred while fetching user data';
      this.isLoading = false;
    }
  },
  methods: {
    ...mapActions(['setUser']),
    goToHome() {
      this.$router.push('/');
    }
  }
};
</script>

<style scoped>
.success-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.success-icon-container {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}

.success-icon {
  font-size: 5rem;
  color: #28a745;
  animation: successPulse 2s ease-in-out;
}

@keyframes successPulse {
  0% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.success-title {
  color: #28a745;
  font-weight: 600;
  font-size: 2.5rem;
}

.success-message {
  color: #6c757d;
  max-width: 600px;
  margin: 0 auto;
}

.premium-features {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 8px;
  padding: 2rem;
  margin: 2rem 0;
}

.feature-item {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  font-size: 1rem;
}

.feature-item i {
  margin-right: 0.75rem;
  font-size: 1.25rem;
  width: 24px;
}

.action-buttons {
  margin: 2rem 0;
}

.receipt-info {
  border-top: 1px solid #e9ecef;
  padding-top: 1rem;
}

@media (max-width: 768px) {
  .success-page {
    padding: 1.5rem;
  }
  
  .success-title {
    font-size: 2rem;
  }
  
  .success-icon {
    font-size: 4rem;
  }
  
  .action-buttons .btn {
    display: block;
    width: 100%;
    margin-bottom: 1rem;
  }
}
</style>
